import { FirebaseRemoteConfigKey, GrowthbookKey, LOCALES } from 'root-constants'
import { Cohort } from './root-constants'

export type TAbTestKey = FirebaseRemoteConfigKey | GrowthbookKey

export const COHORT_FIREBASE_KEYS_MAP: Partial<Record<
  Cohort,
  FirebaseRemoteConfigKey | FirebaseRemoteConfigKey[]
>> = {
  // [Cohort.WOOFZ22_V3]: FirebaseRemoteConfigKey.ABTEST_WEB_1857_DOG_BREED_ID, // example
  [Cohort.WOOFZ22_V4]: [
    FirebaseRemoteConfigKey.ABTEST_WEB_2674_ROVER_PARTNERSHIP2,
  ],
  [Cohort.WOOFZ_WOOFY1]: FirebaseRemoteConfigKey.ABTEST_WEB_3_WOOFY,
  [Cohort.WOOFZ_RFND3]: FirebaseRemoteConfigKey.ABTEST_WEB_2540_FIRST_PAGE21,
  [Cohort.WOOFZ_PUP_BL]:
    FirebaseRemoteConfigKey.ABTEST_WEB_2407_FEEDBACK_SCREEN9,
  [Cohort.WOOFZ_PPP_WOOFY]:
    FirebaseRemoteConfigKey.ABTEST_WEB_2592_WOOFY_CHAT_UPSELL,
  [Cohort.WOOFZ_K9_BL]:
    FirebaseRemoteConfigKey.ABTEST_WEB_2844_SOCIAL_SIGN_UP_K9_BL,
  [Cohort.WOOFZ_K9]: FirebaseRemoteConfigKey.ABTEST_WEB_2844_SOCIAL_SIGN_UP_K9,
  [Cohort.WOOFZ_LOVE_BL]: FirebaseRemoteConfigKey.ABTEST_WEB_2747_SUB_PLANS_PW,
  [Cohort.WOOFZ_SMD_BL]:
    FirebaseRemoteConfigKey.ABTEST_WEB_2854_POST_PURCHASE_REDIRECT,
}

export const COHORT_GROWTHBOOK_KEYS_MAP: Partial<Record<
  Cohort,
  GrowthbookKey | GrowthbookKey[]
>> = {
  [Cohort.WOOFZ_LOVE_BL]: GrowthbookKey.ABTEST_WEB_2763_BRAZIL_PR,
  [Cohort.WOOFZ_K9_BL]: [
    GrowthbookKey.ABTEST_PLT_636_STRIPE_CS,
    GrowthbookKey.ABTEST_WEB_2904_ONE_TIME_UPSELL,
  ],
  [Cohort.WOOFZ_K9_BL_1]: GrowthbookKey.ABTEST_PLT_636_STRIPE_CS,
  [Cohort.WOOFZ_K9_BL_2]: GrowthbookKey.ABTEST_PLT_636_STRIPE_CS,
  [Cohort.WOOFZ_K9_BL_3]: GrowthbookKey.ABTEST_PLT_636_STRIPE_CS,
  [Cohort.WOOFZ_SMD_BL]: GrowthbookKey.ABTEST_WEB_2855_FIRST_PAGE24,
  [Cohort.WOOFZ_K9]: [
    GrowthbookKey.ABTEST_WEB_2889_NEW_PAYWALL,
    GrowthbookKey.ABTEST_WEB_2906_ONE_TIME_UPSELL,
  ],
  [Cohort.WOOFZ_PPP_BL]: [
    GrowthbookKey.ABTEST_WEB_2867_COMMITMENT_SCREEN3,
    GrowthbookKey.ABTEST_WEB_2907_ONE_TIME_UPSELL,
    GrowthbookKey.ABTEST_WEB_2897_SPIN_WHEEL_HALLOWEEN_PUMPKIN,
  ],
  [Cohort.WOOFZ22_V4]:
    GrowthbookKey.ABTEST_WEB_2900_SPIN_WHEEL_HALLOWEEN_PUMPKIN_22V4,
}

export const PAUSED_AB_TEST_KEYS: TAbTestKey[] = [
  GrowthbookKey.ABTEST_WEB_2867_COMMITMENT_SCREEN3,
]

export const AB_TEST_LOCALES_MAP: Partial<Record<
  TAbTestKey,
  string[] | null
>> = {
  [GrowthbookKey.ABTEST_WEB_2763_BRAZIL_PR]: null,
  [GrowthbookKey.ABTEST_PLT_636_STRIPE_CS]: null,
  [GrowthbookKey.ABTEST_WEB_2897_SPIN_WHEEL_HALLOWEEN_PUMPKIN]: null,
  [GrowthbookKey.ABTEST_WEB_2900_SPIN_WHEEL_HALLOWEEN_PUMPKIN_22V4]: null,
}

export const DEFAULT_AB_TEST_LOCALES = [LOCALES.EN]
